import { render, staticRenderFns } from "./BrandsList.vue?vue&type=template&id=19ee0bfa"
import script from "./BrandsList.vue?vue&type=script&lang=js"
export * from "./BrandsList.vue?vue&type=script&lang=js"
import style0 from "./BrandsList.vue?vue&type=style&index=0&id=19ee0bfa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports